module.exports = __webpack_public_path__ + "img/Dropdown.26f623b8.svg";